import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Button, Table, Space, message } from "antd";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import LiensModel from "./LiensModel";
import moment from "moment";
import { useQuery } from "../../../../../helpers/utility";
import {
  createLiens,
  deleteLiens,
  getLiens,
  updateLiens,
} from "../../../../../services/adminForm.services";

const dateFormat = "YYYY-MM-DD";

const BankruptcyLiens = ({ selectedOwner }) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const refreshPage = () => {
    setRefresh((prevValue) => !prevValue);
  };

  const query = useQuery();
  const applicationId = query.get("id");

  const columns = [
    {
      title: "Creditor",
      dataIndex: "creditor",
      key: "creditor",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      ellipsis: true,
      width: 100,
    },
    {
      title: "County",
      dataIndex: "county",
      key: "county",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Property",
      dataIndex: "property",
      key: "property",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing No",
      dataIndex: "filing_no",
      key: "filing_no",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing Date",
      dataIndex: "filing_date",
      key: "filing_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Release Date",
      dataIndex: "release_date",
      key: "release_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  useEffect(() => {
    fetchLiens();
  }, [selectedOwner, refresh]);

  function fetchLiens() {
    getLiens({
      id: applicationId,
      detailsType: "bankruptcy",
      ownership: selectedOwner,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.log("get Bankruptcy liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Something Went Wrong"
          );
        } else {
          message.error("get Bankruptcy liens error");
        }
      });
  }

  function saveLiens(values) {
    let data = values;
    data.filing_date = moment(values.filing_date).format(dateFormat);
    data.release_date = moment(values.release_date).format(dateFormat);
    data.details_type = "bankruptcy";
    data.application = applicationId;
    data.ownership = selectedOwner;

    createLiens(data)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Saved Bankruptcy Liens");
        refreshPage();
      })
      .catch((error) => {
        console.error("save Bankruptcy liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to save Bankruptcy Liens"
          );
        } else {
          message.error("save Bankruptcy lines error");
        }
      });
  }

  function handleUpdateLiens(values) {
    let data = values;
    data.filing_date = moment(values.filing_date).format(dateFormat);
    data.release_date = moment(values.release_date).format(dateFormat);
    data.application = applicationId;
    data.details_type = "bankruptcy";

    updateLiens(editTable.id, data)
      .then((res) => {
        setVisible(false);
        message.success(res.data.message || "Updated Bankruptcy Liens");
        refreshPage();
      })
      .catch((error) => {
        console.error("update Bankruptcy liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to update Bankruptcy Liens"
          );
        } else {
          message.error("update Bankruptcy liens error");
        }
      });
  }

  function removeColumn(id) {
    deleteLiens(id)
      .then((res) => {
        message.success(res.data.message || "Removed Bankruptcy Liens");
        fetchLiens(applicationId, "bankruptcy");
      })
      .catch((error) => {
        console.error("delete Bankruptcy liens error", error);
        if (error && error.response) {
          message.error(
            error.response.data.message ||
              error.response.message ||
              "Failed to remove Bankruptcy Liens"
          );
        } else {
          message.error("delete Bankruptcy liens error");
        }
      });
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <Button
            onClick={() => openModal({ status: "create" })}
            type="secondary"
            style={{
              marginBottom: 16,
            }}
          >
            Add Bankruptcy Details
          </Button>
        </Col>
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            pagination={false}
            dataSource={data}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
      {visible && (
        <LiensModel
          create={saveLiens}
          update={handleUpdateLiens}
          setVisible={setVisible}
          title="Bankruptcy Liens"
          editTable={editTable}
        />
      )}
    </Fragment>
  );
};

export default BankruptcyLiens;
